<template>
    <div class="messages-page">
        <div>
            <div class="title-button">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>Mensagens</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="inbox-messages">
                <div class="row">
                    <div class="col-md-5">
                        <div class="inbox">
                            <label for="search-field">Pesquisar</label>

                            <b-input-group class="search-field right-space">
                                <b-input-group-prepend>
                                    <b-icon icon="search" aria-hidden="true"></b-icon>
                                </b-input-group-prepend>

                                <b-form-input placeholder="Pesquisar" v-model="searchFieldText"></b-form-input>
                            </b-input-group>

                            <div v-if="getMessageData.length">
                                <b-table
                                    :items="getMessageData"
                                    :fields="messageFields"
                                    :busy="false"
                                    class="mt-3"
                                    hover
                                    @row-clicked="showMessagesUser"
                                >
                                    <template #table-busy>
                                        <div class="text-center text-danger my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong>Loading...</strong>
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                            <div v-else class="no-messages">
                                <h5 class="message">Você ainda não possui nenhuma mensagem!</h5>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-7">
                        <div class="messages" v-if="getMessageData.length || getUserReceiveId">
                            <div class="header">
                                <h5 class="name">{{ userReceiveName }}</h5>

                                <div>
                                    <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
                                        <template #button-content>
                                            <b-icon
                                                :variant="!getIsDarkTheme ? 'dark' : 'light'"
                                                icon="three-dots"
                                                aria-hidden="true"
                                            ></b-icon>
                                        </template>
                                        <b-dropdown-item @click="deleteMessages()">
                                            Excluir
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>

                            <div
                                class="message"
                                :class="getOriginType(item)"
                                v-for="(item, index) in getMessagesList"
                                :key="index"
                            >
                                <div class="message-top">
                                    <div class="sender">{{ item.name }}</div>
                                    <div class="date">{{ getDateTimeFormat(item.created_at) }}</div>
                                </div>

                                <div class="text">{{ item.mensagem }}</div>
                            </div>

                            <b-form-textarea
                                id="new-message"
                                name="newMessage"
                                class="radius-6"
                                v-model="newMessage"
                                placeholder="Digite aqui ..."
                                rows="4"
                            ></b-form-textarea>

                            <div class="new-message-button">
                                <b-button
                                    class="icon-button"
                                    variant="primary"
                                    :disabled="[null, ''].includes(newMessage)"
                                    @click="sendMessage()"
                                >
                                    <b-icon icon="envelope" aria-hidden="true"></b-icon>
                                    Enviar mensagem
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <DangerModalPP ref="warningModal" :message="messageModal" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { MessageApi } from '../../../../api/platform/messages'
import { SystemApi } from '../../../../api/system-api'
import { AuthenticationApi } from '../../../../api/authentication'

const messageApi = new MessageApi()
const systemApi = new SystemApi()
const authenticationApi = new AuthenticationApi()

export default {
    components: { DangerModalPP },
    data() {
        return {
            newMessage: null,
            userIdLogged: null,
            currentMessagesUser: null,
            userSendId: null,
            userReceiveId: null,
            userReceiveName: null,
            messageModal: null,
            searchFieldText: '',
            messageFields: [
                {
                    key: 'name',
                    label: 'Nome'
                },
                {
                    key: 'date',
                    label: 'Data'
                }
            ],
            messageData: []
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setUserReceiveId']),
        fetch() {
            this.setIsLoading(true)

            authenticationApi
                .getUser()
                .then(result => {
                    this.userIdLogged = result.data.id

                    messageApi
                        .listMessages()
                        .then(response => {
                            const result = response.data.data

                            if (result) {
                                this.messageData = result
                                if (result.length) {
                                    this.currentMessagesUser = result[0].id
                                    this.userReceiveId =
                                        this.userIdLogged === result[0].user_receive_id
                                            ? result[0].user_send_id
                                            : result[0].user_receive_id
                                    this.userSendId =
                                        this.userIdLogged === result[0].user_send_id
                                            ? result[0].user_send_id
                                            : result[0].user_receive_id
                                    this.userReceiveName = result[0].name
                                }
                            }
                        })
                        .catch(error => {
                            this.messageModal = error.response.data.message
                            this.$refs.warningModal.showModal()
                        })
                        .finally(() => {
                            this.setIsLoading(false)
                        })
                })
                .catch(error => {
                    this.setIsLoading(false)
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
        },
        sendMessage() {
            const data = { user_receive_id: this.userReceiveId, mensagem: this.newMessage }

            this.setIsLoading(true)

            messageApi
                .sendMessage(data)
                .then(() => {
                    this.fetch()
                })
                .catch(error => {
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                    this.newMessage = null
                })
        },
        deleteMessages() {
            const data = {
                id: this.getCurrentMessagesUser,
                user_send_id: this.userSendId,
                user_receive_id: this.userReceiveId
            }

            this.setIsLoading(true)

            messageApi
                .deleteMessages(data)
                .then(() => {
                    this.fetch()
                })
                .catch(error => {
                    this.messageModal = error.response.data.message
                    this.$refs.warningModal.showModal()
                    this.setIsLoading(false)
                })
        },
        showMessagesUser(row) {
            this.currentMessagesUser = row.id
            this.userSendId = row.user_send_id
            this.userReceiveId = row.user_receive_id
            this.userReceiveName = row.name
        },
        getDateTimeFormat(dateText) {
            return systemApi.getDateTimeFormat(dateText)
        },
        getOriginType(item) {
            return this.userIdLogged === item.user_send_id ? 'send' : 'receive'
        }
    },
    computed: {
        getMessageData() {
            return this.messageData
                .map(item => ({ ...item, date: this.getDateTimeFormat(item.data) }))
                .filter(res => res.name.toLowerCase().includes(this.searchFieldText.toLowerCase()))
        },
        getCurrentMessagesUser() {
            return this.currentMessagesUser
        },
        getMessagesList() {
            if (this.getCurrentMessagesUser) {
                return this.messageData.filter(item => item.id === this.getCurrentMessagesUser)[0].objectMessage
            } else return []
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getUserReceiveId() {
            return this.$store.state.userReceiveId
        }
    },
    beforeRouteLeave(to, from, next) {
        this.setUserReceiveId(null)
        next()
    },
    mounted() {
        if (this.getUserReceiveId) {
            this.userReceiveId = this.getUserReceiveId
        }
        this.fetch()
    }
}
</script>

<style scope src="./MessagesPage-light-theme.css"></style>
<style scope src="./MessagesPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-page/messages-page/MessagesPage.vue